/**
 * Store-independent SVG element effects for project rendering.
 */

import type { OfferingModel } from '@sosocio/creator-types/database';
import { addSvgPrintEffect } from '@sosocio/tools/svg';

/**
 * Adds the configured embossing or engraving filter to an SVG element.
 *
 * @param svgElement SVG element to update.
 * @param printEffect Offering print effect to render.
 */
export function svgAddPrintEffect(
	svgElement: SVGElement,
	printEffect: OfferingModel['printEffect'],
): void {
	addSvgPrintEffect(
		svgElement,
		printEffect,
	);
}
